async function ConsultaGetOne(fecha, horario) {
    // Detectamos si estamos en local o en producción
    const baseUrl = window.location.hostname === 'localhost' 
        ? 'http://localhost:4000' 
        : 'https://vetladradoc.uy';

    return await fetch(`${baseUrl}/api/consulta/getOne`, {
        method: "POST",
        // Importante para Passport: permite enviar las cookies de sesión
        credentials: "include", 
        body: JSON.stringify({ fecha, horario }),
        headers: {
            "Content-Type": "application/json"
        }
    });
}

export default ConsultaGetOne;